import React from 'react';
import PageInfo from '../components/PageInfo';
export default function NoMatch() {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:pt-16">
            <PageInfo title="404 Error" subtitle="" />
        </div>
    );
}